import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { services } from "../data/site";
import useDynamicContent from "../hooks/useDynamicContent";

export default function ServicesSection() {
  const { content } = useDynamicContent('home');
  const title = content.services_title || "Our 360° Land Development Solutions.";
  const subtitle = content.services_subtitle || "We help you develop your land independently. Our comprehensive pillars cover everything you need from architectural designs and approvals to funding, construction, and marketing.";

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 md:py-40 px-6 md:px-12 bg-[#0c0c0f]"
    >
      <div className="absolute inset-0 blueprint-grid opacity-[0.04]" />
      <div className="relative max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <SectionHeading
            eyebrow="Services"
            title={title}
            testId="services-heading"
          />
          <p className="text-white/55 max-w-md text-sm md:text-base">
            {subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/[0.06] border border-white/[0.06] rounded-3xl overflow-hidden">
          {services.map((s, i) => (
            <motion.a
              key={s.code}
              href="#contact"
              data-testid={`service-card-${s.code.toLowerCase()}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.06 }}
              className="card-ring relative group p-8 md:p-10 bg-[#0F0F12] hover:bg-[#15151a] transition-all min-h-[260px] flex flex-col justify-between"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-[#C96A2B] text-3xl">{s.code}</span>
                <span className="h-9 w-9 rounded-full border border-white/10 grid place-items-center group-hover:border-[#C96A2B] group-hover:text-[#C96A2B] transition-colors">
                  <ArrowUpRight size={16} />
                </span>
              </div>

              <div className="mt-12">
                <h3 className="font-display text-xl md:text-2xl leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-white/55 leading-relaxed line-clamp-3">
                  {s.desc}
                </p>
              </div>

              <span className="absolute bottom-0 left-0 h-px w-0 bg-[#C96A2B] group-hover:w-full transition-all duration-700" />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
